import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=786d85a3"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"
import style0 from "./PageLoader.vue?vue&type=style&index=0&id=786d85a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports